













































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Survey } from '../../model/api';
import AppBase from '../common/base';

@Component
export default class SurveyLanding extends AppBase {
    isLogin = false;
    survey: Survey = <Survey>{};

    async created() {
        this.$store.commit('setTheme', { theme: this.slug });
        let data = await this.$store.dispatch('loadSurveyLanding', { slug: this.slug });
        if (data) {
            this.survey = data.survey;
        }
    }

    get state() {
        return this.$route.query && this.$route.query.state || '';
    }

    get r() {
        return this.$route.query && this.$route.query.r || '';
    }

    get fbpixelid() {
        return this.$route.query && this.$route.query.fbpixelid || '';
    }

    get coverImage() {
        return '/_assets/resources/surveys/' + this.slug + '/landing.jpg?v=1';
    }

    get slug() {
        return this.$route.params.slug;
    }

    get callToAction(){
        let text = this.survey.texts;
        if (text) {
            return text[this.lang].Widgets.CallToAction;
        }
        return null;
    }

    onShare() {
        (<any>window).FB.ui({
            method: 'share',
            href: window.location.href
        });
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/signup/survey-landing.vue